import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AdminConsultationService } from '../../../shared/services/admin-consultation.service';
import { IAdminBooking, IAdminSlot, IRescheduleBookingRequest } from '../../../../assets/types/dtoTypes';

@Component({
  selector: 'app-reschedule-booking-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reschedule-booking-modal.component.html',
  styleUrls: ['./reschedule-booking-modal.component.scss'],
})
export class RescheduleBookingModalComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<RescheduleBookingModalComponent>);
  private adminService = inject(AdminConsultationService);
  data = inject<{ booking: IAdminBooking }>(MAT_DIALOG_DATA);

  slots: IAdminSlot[] = [];
  loading = true;
  loadError = false;
  selectedSlotId = '';
  notes = '';

  ngOnInit(): void {
    const from = new Date();
    const to = new Date();
    to.setDate(to.getDate() + 60);
    this.adminService.listSlots(from, to)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (slots) => {
          // Bookable, future slots that are not the slot the booking is already on.
          this.slots = slots.filter(s => s.available && s.id !== this.data.booking.slotId);
        },
        error: () => (this.loadError = true),
      });
  }

  get isValid(): boolean {
    return this.selectedSlotId.length > 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.isValid) return;
    const result: IRescheduleBookingRequest = {
      newSlotId: this.selectedSlotId,
      notes: this.notes.trim() || undefined,
    };
    this.dialogRef.close(result);
  }
}
